<template>
  <div class="content">我是费率调整页面</div>
</template>
<script>
export default {
  name: "InteresRate",
};
</script>
<style scoped></style>
